import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Box,
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import EarningGraph from "../../features/dashboard/earningGraph";
import SearchBar from "../../components/SearchBar";
import React, { useState } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MetricCard from "../dashboard/MetricCard";
import FilterMenu from "../../components/filterMenu";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ManageAnalytics = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);

  const rows = [
    {
      name: "Madelyn Dias",
      email: "abdul@sample.com",
      membershipType: "Single",
      membershipStatus: "Paid",
      paymentStatus: "Paid",
      createdDate: "18 – June – 2025 | 6:00PM",
      avatar: "", // optional avatar path
    },
    {
      name: "Madelyn Dias",
      email: "abdul@sample.com",
      membershipType: "Duo",
      membershipStatus: "Complimentary",
      paymentStatus: "Pending",
      createdDate: "18 – June – 2025 | 6:00PM",
    },
    // more records...
  ];
  const rows1 = [
    {
      bookingId: "1",
      name: "John Smith",
      phone: "+971 (0) 567894623",
      offerName: "The Residence Tunis",
      bookingTime: "2nd-June-2025 | 6:00PM",
      guests: "04",
      category: "Dining",
      employeeName: "John Smith",
      internalStatus: "New",
      avatar: "/static/images/user_placeholder.png",
      reason:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate, quia!",
      amount: "AED 5000",
    },
    {
      bookingId: "5",
      name: "Ethan Hunt",
      phone: "+971 (0) 567894614",
      offerName: "Wedding Event",
      bookingTime: "6th-June-2025 | 5:00PM",
      guests: "10",
      category: "Event",
      employeeName: "Steve Rogers",
      internalStatus: "New",
      avatar: "/static/images/user_placeholder.png",
      reason:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate, quia!",
      amount: "AED 3500",
    },
    {
      bookingId: "9",
      name: "Chandler Bing",
      phone: "+971 (0) 567894618",
      offerName: "Desert Safari",
      bookingTime: "10th-June-2025 | 4:00PM",
      guests: "0",
      category: "Experience",
      employeeName: "Natasha Romanoff",
      internalStatus: "New",
      avatar: "/static/images/user_placeholder.png",
      reason:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate, quia!",
      amount: "AED 2000",
    },
  ];

  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");

  const handleClose = () => {
    setOpen(false);
  };
  const handleChange1 = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setSelectedValue(event.target.value);
    setOpen(false); // close after selecting
  };
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  return (
    <MainContainer>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Manage Analytics</h1>
        </div>
        <div className="right_s">

          <Button className="btn btn_primary">
            <DownloadIcon /> Export
          </Button>
        </div>
      </div>
      <Box className="custom_tabs1" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
          className="custom_tabs_links"
        >
          <Tab label="Member Reports" {...a11yProps(0)} />
          <Tab label="Booking Reports" {...a11yProps(1)} />
          <Tab label="Cancellation Reports" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTabs} index={0}>
        <div className="main_title d_flex mt_30">
          <div className="left_s">
            <SearchBar searchTerm={""} placeholder={"Search..."} />
          </div>
          <div className="right_s">
            <FilterMenu  tabIndex={valueTabs}/>
            {/* <Select
              open={open}
              onClose={handleClose}
              onOpen={() => setOpen(true)}
              value={selectedValue}
              onChange={handleChange1}
              displayEmpty
              inputProps={{
                "aria-label": "Without label",
              }}
              className="dropse"
            >
              <MenuItem value="" disabled>
                Filter
              </MenuItem>
              <MenuItem value="10">Active Members (Last 30 Days)</MenuItem>
              <MenuItem value="20">Inactive Members</MenuItem>
              <MenuItem value="30">Trial Members </MenuItem>
              <MenuItem value="40">Expiring Memberships</MenuItem>
              <MenuItem value="50">New Member Signups</MenuItem>
            </Select> */}
          </div>
        </div>
        <div className="cards table_cards mt_20">
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead
                style={{
                  backgroundColor: "#C19857",
                  color: "#fff",
                  textAlign: "left",
                }}
              >
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Membership Type</th>
                  <th>Membership Status</th>
                  <th>Payment Status</th>
                  <th>Created Date</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr
                    key={index}
                    style={{ color: "#fff", borderBottom: "1px solid #444" }}
                  >
                    <td
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img
                        src={
                          row.avatar || "/static/images/user_placeholder.png"
                        }
                        alt={row.name}
                        style={{ width: 32, height: 32, borderRadius: "50%" }}
                      />
                      {row.name}
                    </td>
                    <td>{row.email}</td>
                    <td>{row.membershipType}</td>
                    <td>{row.membershipStatus}</td>
                    <td>{row.paymentStatus}</td>
                    <td>{row.createdDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs} index={1}>
        <div className="stats_boxes gap_m mt_20">
          <MetricCard
            title="Total Booking Revenue"
            value="AED 12240"
            subtext="↑ 5% from last month"
          />
        </div>
        <div className="main_title d_flex mt_30">
          <div className="left_s">
            <SearchBar searchTerm={""} placeholder={"Search..."} />
          </div>
          <div className="right_s">
            <FilterMenu  tabIndex={valueTabs}/>
            {/* <Select
              open={open}
              onClose={handleClose}
              onOpen={() => setOpen(true)}
              value={selectedValue}
              onChange={handleChange1}
              displayEmpty
              inputProps={{
                "aria-label": "Without label",
              }}
              className="dropse"
            >
              <MenuItem value="" disabled>
                Filter
              </MenuItem>
              <MenuItem value="10">Bookings by Date Range</MenuItem>
              <MenuItem value="20">Top Performing Offers</MenuItem>
            </Select> */}
            {/* <div className="gap_p" style={{ flexWrap: "nowrap" }}>
              <div
                className="w_50 control_group"
                style={{ marginBottom: "0", width: "160px" }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                      textField: (params) => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder="Start Date"
                          hiddenLabel
                        />
                      ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>

              <div
                className="control_group"
                style={{ marginBottom: "0", width: "160px" }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                      textField: (params) => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder="End Date"
                          hiddenLabel
                        />
                      ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>
            </div> */}
          </div>
        </div>
        <div className="cards table_cards mt_20">
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead
                style={{
                  backgroundColor: "#C19857",
                  color: "#fff",
                  textAlign: "left",
                }}
              >
                <tr>
                  <th>Booking ID</th>
                  <th>Client Detail</th>
                  <th>Offer Name</th>
                  <th>Booking Time</th>
                  <th>Guests</th>
                  <th>Category</th>
                  <th>Employee Name</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                {rows1.map((row, index) => (
                  <tr
                    key={index}
                    style={{ color: "#fff", borderBottom: "1px solid #444" }}
                  >
                    <td>{row.bookingId}</td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>{row.name}</span>
                        </div>
                        <div>{row.phone}</div>
                      </div>
                    </td>
                    <td
                      onClick={() =>
                        navigate("/manage-booking-resvp/booking-detail")
                      }
                      className="cursor_p"
                    >
                      {row.offerName}
                    </td>
                    <td>{row.bookingTime}</td>
                    <td>{row.guests}</td>
                    <td>{row.category}</td>
                    <td
                      className="cursor_p"
                      onClick={() => navigate("/manage-customers/detail")}
                    >
                      {row.employeeName}
                    </td>
                    <td>{row.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs} index={2}>
        <div className="main_title d_flex mt_30">
          <div className="left_s">
            <SearchBar searchTerm={""} placeholder={"Search..."} />
          </div>
        </div>{" "}
        <div className="cards table_cards mt_20">
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead
                style={{
                  backgroundColor: "#C19857",
                  color: "#fff",
                  textAlign: "left",
                }}
              >
                <tr>
                  <th>Booking ID</th>
                  <th>Client Detail</th>
                  <th>Offer Name</th>
                  <th>Booking Time</th>
                  <th>Guests</th>
                  <th>Category</th>
                  <th>Employee Name</th>
                  <th>Cancellation Reason</th>
                </tr>
              </thead>

              <tbody>
                {rows1.map((row, index) => (
                  <tr
                    key={index}
                    style={{ color: "#fff", borderBottom: "1px solid #444" }}
                  >
                    <td>{row.bookingId}</td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>{row.name}</span>
                        </div>
                        <div>{row.phone}</div>
                      </div>
                    </td>
                    <td
                      onClick={() =>
                        navigate("/manage-booking-resvp/booking-detail")
                      }
                      className="cursor_p"
                    >
                      {row.offerName}
                    </td>
                    <td>{row.bookingTime}</td>
                    <td>{row.guests}</td>
                    <td>{row.category}</td>
                    <td
                      className="cursor_p"
                      onClick={() => navigate("/manage-customers/detail")}
                    >
                      {row.employeeName}
                    </td>
                    <td>{row.reason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CustomTabPanel>
    </MainContainer>
  );
};

export default ManageAnalytics;
